'use client';

import { Input } from './input';
import { Label } from './label';
import { cn } from '@/lib/utils';

interface FormFieldProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label: string;
  error?: string;
}

export function FormField({ label, error, className, ...props }: FormFieldProps) {
  return (
    <div className="space-y-2">
      <Label 
        htmlFor={props.name}
        className={cn(
          "text-sm font-medium",
          error && "text-destructive"
        )}
      >
        {label}
      </Label>
      <Input
        {...props}
        id={props.name}
        className={cn(
          className,
          error && "border-destructive focus-visible:ring-destructive"
        )}
      />
      {error && (
        <p className="text-sm text-destructive">{error}</p>
      )}
    </div>
  );
}